import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Skeleton } from '@/components/ui/skeleton.component';

export function EntityActionLoading() {
  return (
    <Skeleton
      className="h-10 flex-1 min-w-0 rounded-lg"
      data-testid={DataTestIdEnum.ENTITY_ACTION_LOADING}
    />
  );
}
